// ── PALETTE (copia locale — identica a App.js) ────────────────────────────────
const P = {
  bg:"#080B14", card:"#0D1020", border:"#1D2238",
  gold:"#E9622A", goldGlow:"rgba(233,98,42,0.12)", goldBorder:"rgba(233,98,42,0.30)",
  text:"#EBE8F5", muted:"#8A8EAE", secondary:"#B4B7D0",
  green:"#5BB87A", yellow:"#E9622A", red:"#C46B6B", blue:"#5A82B8", purple:"#a78bfa",
  sidebar:"#060810", card2:"#111525", card3:"#161B2E",
  borderSubtle:"#141829", borderStrong:"#2A3055"
};

const mc = (m, colors) => colors[m] || P.gold;

const Avatar = ({nome, color, size=30}) => (
  <div style={{width:size,height:size,borderRadius:"50%",background:`${color}20`,
    border:`1px solid ${color}44`,display:"flex",alignItems:"center",
    justifyContent:"center",fontSize:size*0.4,color,fontWeight:700,flexShrink:0}}>
    {nome.charAt(0)}
  </div>
);

const Badge = ({label, color}) => (
  <span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:12,padding:"3px 9px",
    borderRadius:99,fontWeight:400,letterSpacing:0.3,
    color,background:`${color}15`,border:`1px solid ${color}30`}}>
    {label}
  </span>
);

// ── PROPS ─────────────────────────────────────────────────────────────────────
// pagamenti        : array  — lista pagamenti
// maestriColors    : object — mappa nome→colore
// isMobile         : bool
// goToAllievo      : fn(id)
// togglePagamento  : fn(id)

export default function Pagamenti({ pagamenti, maestriColors, isMobile, goToAllievo, togglePagamento }) {
  const statoInfo = (st) => st==="pagato"
    ? {bg:"rgba(52,120,80,0.15)",color:P.green,label:"Pagato",border:"rgba(52,120,80,0.35)"}
    : st==="ritardo"
    ? {bg:"rgba(180,60,60,0.15)",color:P.red,label:"In ritardo",border:"rgba(180,60,60,0.35)"}
    : {bg:P.goldGlow,color:P.gold,label:"In attesa",border:P.goldBorder};

  return (
    <div style={{animation:"fi .35s ease"}}>
      <div style={{marginBottom:26}}>
        <div style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:11,letterSpacing:3,color:P.muted,marginBottom:7,fontWeight:400,textTransform:"uppercase"}}>GESTIONE</div>
        <div style={{display:"flex",alignItems:"center"}}>
          <h1 style={{fontFamily:"'Syne',sans-serif",fontSize:isMobile?22:32,fontWeight:800,letterSpacing:-0.5}}>Allievi</h1>
        </div>
      </div>
      <div style={{background:P.card,border:`1px solid ${P.border}`,borderRadius:14,overflow:"hidden"}}>
        <table style={{width:"100%",borderCollapse:"collapse"}}>
          <thead>
            <tr style={{borderBottom:`1px solid ${P.border}`}}>
              <th style={{padding:"13px 16px",textAlign:"center",fontFamily:"'IBM Plex Mono',monospace",fontSize:11,letterSpacing:2,color:P.muted,fontWeight:400,width:40}}>#</th>
              {["Allievo","Maestro","Importo","Metodo","Note","Stato"].map(h=>(
                <th key={h} style={{padding:"13px 16px",textAlign:"left",fontFamily:"'IBM Plex Mono',monospace",fontSize:11,letterSpacing:2,color:P.muted,fontWeight:400}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {[...pagamenti].sort((a,b)=>a.id-b.id).map((p,i)=>{
              const c=mc(p.maestro,maestriColors);
              const si=statoInfo(p.stato);
              return (
                <tr key={p.id} style={{borderBottom:i<pagamenti.length-1?`1px solid ${P.border}`:"none"}}
                  onMouseEnter={e=>e.currentTarget.style.background=`${c}08`}
                  onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                  <td style={{padding:"12px 16px",textAlign:"center",color:P.muted,fontSize:14,fontWeight:600}}>{i+1}</td>
                  <td style={{padding:"12px 16px"}}>
                    <div style={{display:"flex",alignItems:"center",gap:9}}>
                      <div onClick={()=>goToAllievo(p.id)}
                        title="Clicca per vedere il calendario presenze"
                        style={{cursor:"pointer",transition:"transform .15s, box-shadow .15s",flexShrink:0}}
                        onMouseEnter={e=>{e.currentTarget.style.transform="scale(1.18)";e.currentTarget.style.boxShadow=`0 0 0 3px ${c}44`;}}
                        onMouseLeave={e=>{e.currentTarget.style.transform="scale(1)";e.currentTarget.style.boxShadow="none";}}>
                        <Avatar nome={p.nome} color={c} size={28}/>
                      </div>
                      <span style={{fontSize:15,fontWeight:500}}>{p.nome}</span>
                    </div>
                  </td>
                  <td style={{padding:"12px 16px"}}><Badge label={p.maestro} color={c}/></td>
                  <td style={{padding:"12px 16px"}}>
                    <span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:16,fontWeight:500,color:P.gold}}>€{p.retta}</span>
                  </td>
                  <td style={{padding:"12px 16px",color:P.muted,fontSize:14}}>{p.metodo||"—"}</td>
                  <td style={{padding:"12px 16px",fontSize:13,color:P.muted,maxWidth:150}}>{p.note||"—"}</td>
                  <td style={{padding:"12px 16px"}}>
                    <span onClick={()=>togglePagamento(p.id)}
                      style={{display:"inline-flex",alignItems:"center",gap:5,fontFamily:"'IBM Plex Mono',monospace",
                        fontSize:12,padding:"3px 9px",borderRadius:99,fontWeight:400,letterSpacing:0.3,
                        cursor:"pointer",background:si.bg,color:si.color,border:`1px solid ${si.border}`,userSelect:"none"}}>
                      <span style={{width:5,height:5,borderRadius:"50%",background:"currentColor",display:"inline-block"}}/>
                      {si.label}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
